import { TreeGridEvent } from '../classes/treegrid-event.class'

export const useEventBuilderMixin = {
  methods: {
    buildEvent (type, options = {}) {
      return new TreeGridEvent(type, {
        cancelable: false,
        target: this.$el || null,
        relatedTarget: null,
        trigger: null,

        ...options,

        vueTarget: this,
        componentId: this._uid
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/treegrid/mixins/useEventBuilderMixin.js